import { useLocation } from "react-router-dom";
import LEGAL from "@/data/legal.json";
import PageHeader, { usePageTitle } from "@/components/PageHeader";
import { openCookieBanner } from "@/lib/consent";

export default function LegalPage() {
  const { pathname } = useLocation();
  const page = LEGAL[pathname];
  usePageTitle(pathname);
  return (
    <main data-testid={`legal-page-${pathname.slice(1)}`}>
      <PageHeader testId="legal-header" eyebrow={page.eyebrow} title={page.title} lead={page.updated} />
      <section className="bg-ink">
        <div className="mx-auto max-w-3xl space-y-12 px-6 py-20 md:py-28">
          {page.sections.map((s) => (
            <div key={s.h2}>
              <h2 className="font-display text-2xl font-bold uppercase text-white">{s.h2}</h2>
              <div className="mt-4 space-y-4 text-base leading-relaxed text-white/65">
                {s.p.map((t) => <p key={t.slice(0, 30)}>{t}</p>)}
              </div>
            </div>
          ))}
          {pathname === "/cookie-policy" && (
            <button
              type="button"
              onClick={openCookieBanner}
              data-testid="legal-cookie-preferences"
              className="rounded-md bg-brand px-8 py-4 text-xs font-semibold uppercase tracking-[0.18em] text-white hover:bg-brand-hover"
            >
              Modifica preferenze cookie
            </button>
          )}
        </div>
      </section>
    </main>
  );
}
